import GraphFuncs from "./GraphFuncs";

const { isEmpty } = require("./utils");

const DiagramFuncs = {
  getCircuitsByEg: (eg, channels) => {
    let circuits = new Set()
    let group = eg.replace("Group: ", "")
    for (let channel of channels) {
      if (channel.equipment_group === group) {
        circuits.add(channel.id)
      }
    }
    return Array.from(circuits)
  },

  // Select option of circuits
  selectCircuit: (elems, nodeSelected, setNodeSelected, buildingInfo) => {
    let tempNodeSelected = JSON.parse(JSON.stringify(nodeSelected))
    if (!Array.isArray(elems)) elems = [elems]
    for (let elem of elems) {
      if (elem.target.value && elem.target.value !== "all") {
        if (!(elem.target.value in tempNodeSelected)) {
          tempNodeSelected[elem.target.value] = { name: elem.target.value, dataType: elem.target.name, actuatorId: elem.target.actuatorId}
          if (elem.target.name === 'equipment_group') {
            let egCircuits = DiagramFuncs.getCircuitsByEg(elem.target.value, buildingInfo.e_channels)
            for (let c of egCircuits) {
              tempNodeSelected[c] = { name: c, dataType: 'circuit' }
            }
          }
          if (elem.target.name === 'device') {
            let devCircuits = DiagramFuncs.getCircuitsByDevice(elem.target.value.split(" ")[1], [...buildingInfo.e_channels, ...buildingInfo.g_channels, ...buildingInfo.w_channels])
            for (let c of devCircuits) {
              tempNodeSelected[c] = { name: c, dataType: 'circuit' }
            }
          }
          if (elem.target.name === 'category') {
            let egCircuits = DiagramFuncs.getCircuitsByCategory(elem.target.value, buildingInfo.e_channels)
            for (let c of egCircuits) {
              tempNodeSelected[c] = { name: c, dataType: 'circuit' }
            }
            let subcats = DiagramFuncs.getSubcatByCategory(elem.target.value, buildingInfo.e_channels)
            for (let s of subcats) {
              tempNodeSelected[(elem.target.value + s)] = { name: s, dataType: 'sub_category' }
            }
          }
          if (elem.target.name === 'sub_category') {
            let egCircuits = DiagramFuncs.getCircuitsBySubcategory(elem.target.value, buildingInfo.e_channels)
            for (let c of egCircuits) {
              tempNodeSelected[c] = { name: c, dataType: 'circuit' }
            }
          }
        } else {
          delete tempNodeSelected[elem.target.value]
          if (elem.target.name === 'circuit') {
            // Get cat
            let cat = DiagramFuncs.getCatByCirctuit(elem.target.value, buildingInfo.e_channels)
            // Delet cat selection
            delete tempNodeSelected[cat]
            // Get subcats
            let subcats = DiagramFuncs.getSubcatByCategory(cat, buildingInfo.e_channels)
            // Delete subcat selections
            for (let s of subcats) {
              delete tempNodeSelected[(cat + s)]
            }
            // Get EG
            let eg = DiagramFuncs.getEgByCirctuit(elem.target.value, buildingInfo.e_channels)
            // Delete EG selection
            delete tempNodeSelected[eg]
          }
          if (elem.target.name === 'equipment_group') {
            let egCircuits = DiagramFuncs.getCircuitsByEg(elem.target.value, buildingInfo.e_channels)
            for (let c of egCircuits) {
              delete tempNodeSelected[c]
            }
          }
          if (elem.target.name === 'device') {
            let egCircuits = DiagramFuncs.getCircuitsByDevice(elem.target.value.split(" ")[1], [...buildingInfo.e_channels, ...buildingInfo.g_channels, ...buildingInfo.w_channels])
            for (let c of egCircuits) {
              delete tempNodeSelected[c]
            }
          }
          else if (elem.target.name === 'category') {
            let egCircuits = DiagramFuncs.getCircuitsByCategory(elem.target.value, buildingInfo.e_channels)
            for (let c of egCircuits) {
              delete tempNodeSelected[c]

            }
            let subcats = DiagramFuncs.getSubcatByCategory(elem.target.value, buildingInfo.e_channels)
            for (let s of subcats) {
              delete tempNodeSelected[(elem.target.value + s)]
            }
          }
          else if (elem.target.name === 'sub_category') {
            let egCircuits = DiagramFuncs.getCircuitsBySubcategory(elem.target.value, buildingInfo.e_channels)
            for (let c of egCircuits) {
              delete tempNodeSelected[c]
            }
          }
        }
      } else if (elem.target.value === "all") {
        tempNodeSelected = {}
      }
      setNodeSelected(tempNodeSelected);
    }
  },

  getCircuitsByCategory: (cat, channels) => {
    let circuits = new Set()
    for (let channel of channels) {
      if (channel.category === cat) {
        circuits.add(channel.id)
      }
    }
    return Array.from(circuits)
  },

  getSubcatByCategory: (cat, channels) => {
    let subcats = new Set()
    for (let channel of channels) {
      if (channel.category === cat) {
        let subcat = channel.sub_category
        if (subcat === null) subcat = channel.category
        subcats.add(subcat)
      }
    }
    return Array.from(subcats)
  },

  getCircuitsBySubcategory: (subcat, channels) => {
    let circuits = new Set()
    for (let channel of channels) {
      let tempsubcat = channel.sub_category
      if (tempsubcat === null) tempsubcat = channel.category
      if ((channel.category + tempsubcat) === subcat) {
        circuits.add(channel.id)
      }
    }
    return Array.from(circuits)
  },

  getCatByCirctuit: (circuit, channels) => {
    for (let channel of channels) {
      if (channel.channel_name === circuit) {
        return channel.category
      }
    }
  },

  getEgByCirctuit: (circuit, channels) => {
    for (let channel of channels) {
      if (channel.channel_name === circuit) {
        return "Group: " + channel.equipment_group
      }
    }
  },

  getCircuitsByDevice: (device, channels) => {
    let circuits = new Set()
    for (let channel of channels) {
      if (channel.device_id === device) {
        circuits.add(channel.id)
      }
    }
    return Array.from(circuits)
  },

  getChildren: (tempHierarchy, parentId, nodes) => {
    for (let n of tempHierarchy) {
      if (String(n.parent) === String(parentId)) {
        nodes.push(n.id);
        DiagramFuncs.getChildren(tempHierarchy, n.id, nodes);
      }
    }
  },

  getImmediateChildren: (tempHierarchy, parentId, nodes) => {
    for (let n of tempHierarchy) {
      if (String(n.parent) === String(parentId)) {
        nodes.push(n.id);
      }
    }
  },

  getTree: (buildingInfo, maptype, selectedBuildings, alerts) => {
    let auxHierarchy = []
    switch (maptype) {
      case "1": default:
        DiagramFuncs.treeGenerator(auxHierarchy, buildingInfo.hierarchy, null, selectedBuildings, alerts)
        DiagramFuncs.addSources(auxHierarchy, buildingInfo.e_sources, buildingInfo.hierarchy)
        break

      case "2":
        DiagramFuncs.egTreeGenerator(auxHierarchy, buildingInfo.e_channels, selectedBuildings, alerts)
        break

      case "3":
        DiagramFuncs.catTreeGenerator(auxHierarchy, buildingInfo.e_channels, selectedBuildings, alerts)
        break

      case "4":
        DiagramFuncs.dTreeGenerator(auxHierarchy, buildingInfo.g_hierarchy, null, selectedBuildings, 'gas', alerts, buildingInfo.actuators)
        break

      case "5":
        DiagramFuncs.dTreeGenerator(auxHierarchy, buildingInfo.w_hierarchy, null, selectedBuildings, 'water', alerts, buildingInfo.actuators)
        break
      
      case "6":
        DiagramFuncs.deviceTreeGenerator(auxHierarchy,[...buildingInfo.e_channels, ...buildingInfo.g_channels, ...buildingInfo.w_channels], selectedBuildings, alerts)
        break
    }

    return auxHierarchy
  },

  // Recursive hierarchy generator
  treeGenerator: (auxHierarchy, hierarchy, parent, selectedBuildings, alerts) => {
    for (let key in hierarchy) {
      if (selectedBuildings.length > 0 && !selectedBuildings.includes(hierarchy[key].building_distribution)) continue
      let node = {
        id: hierarchy[key].id,
        name: hierarchy[key].channel_name.trim(),
        device: hierarchy[key].device_id.trim(),
        channel_id: hierarchy[key].id,
        phasing_error: hierarchy[key].phasing_error,
        alerts: alerts[hierarchy[key].id],
        naturalGasUser: hierarchy[key].natural_gas_user,
        parent: parent,
        selected: false,
        collapsed: false,
        dataType: 'circuit',
        shape: {
          type: "HTML",
          content: hierarchy[key].channel_name.trim(),
        },
      };
      auxHierarchy.push(node);
      if (!isEmpty(hierarchy[key].children)) {
        DiagramFuncs.treeGenerator(auxHierarchy, hierarchy[key].children, key, selectedBuildings, alerts);
      }
    }
  },

  egTreeGenerator: (auxHierarchy, channels, selectedBuildings, alerts) => {
    let addedCircuits = []
    let equipmentGroups = []
    for (let channel of channels) {
      if (selectedBuildings.length > 0 && !selectedBuildings.includes(channel.building_distribution)) continue
      if (channel.equipment_group && !equipmentGroups.includes(channel.equipment_group)) {
        let node = {
          id: "Group: " + channel.equipment_group.trim(),
          channel_id: "Group: " + channel.equipment_group.trim(),
          name: "Group: " + channel.equipment_group.trim(),
          parent: null,
          selected: false,
          collapsed: false,
          dataType: 'equipment_group',
          shape: {
            type: "HTML",
            content: "Group: " + channel.equipment_group.trim(),
          },
        };
        auxHierarchy.push(node);
        equipmentGroups.push(channel.equipment_group.trim(),)
      }
      if (channel.equipment_group && !addedCircuits.includes(channel.channel_name.trim())) {
        let node = {
          id: channel.channel_name.trim(),
          name: channel.channel_name.trim(),
          alerts: alerts[channel.id],
          channel_id: channel.id,
          phasing_error: channel.phasing_error,
          parent: "Group: " + channel.equipment_group.trim(),
          selected: false,
          collapsed: false,
          device: channel.device_id.trim(),
          dataType: 'circuit',
          shape: {
            type: "HTML",
            content: channel.channel_name.trim(),
          },
        };
        auxHierarchy.push(node);
        addedCircuits.push(channel.channel_name.trim())
      }
    }
  },

  catTreeGenerator: (auxHierarchy, channels, selectedBuildings, alerts) => {
    channels = GraphFuncs.getNonSubmonitored(channels)
    let addedCircuits = []
    let categories = {}
    for (let channel of channels) {
      if (selectedBuildings.length > 0 && !selectedBuildings.includes(channel.building_distribution)) continue
      if (channel.category !== null && !Object.keys(categories).includes(channel.category.trim())) {
        if (channel.category.trim() === '') channel.category = "Other"
        let node = {
          id: channel.category.trim(),
          channel_id: channel.category.trim(),
          name: channel.category.trim(),
          parent: null,
          selected: false,
          collapsed: false,
          dataType: 'category',
          shape: {
            type: "HTML",
            content: channel.category.trim(),
          },
        };
        auxHierarchy.push(node);
        categories[channel.category.trim()] = []
      }
      let subcat = channel.category !== null && (channel.sub_category === null ? channel.category.trim() : channel.sub_category.trim())
      if (channel.category !== null && !categories[channel.category.trim()].includes(subcat)) {
        if (subcat === '') subcat = 'Other'
        let node = {
          id: channel.category.trim() + subcat,
          channel_id: channel.category.trim() + subcat,
          name: subcat,
          parent: channel.category.trim(),
          selected: false,
          collapsed: false,
          dataType: 'sub_category',
        }
        auxHierarchy.push(node);
        categories[channel.category.trim()].push(subcat)
      }
      if (channel.category !== null && !addedCircuits.includes(channel.channel_name.trim())) {
        if (channel.channel_name.trim() === '') channel.channel_name = "Other"
        let node = {
          id: channel.id,
          name: channel.channel_name.trim(),
          channel_id: channel.id,
          phasing_error: channel.phasing_error,
          alerts: alerts[channel.id],
          parent: channel.category.trim() + subcat,
          selected: false,
          collapsed: false,
          device: channel.device_id.trim(),
          dataType: 'circuit',
          shape: {
            type: "HTML",
            content: channel.channel_name.trim(),
          },
        };
        auxHierarchy.push(node);
        addedCircuits.push(channel.channel_name.trim())
      }
    }
  },

  dTreeGenerator: (auxHierarchy, hierarchy, parent, selectedBuildings, type, alerts, actuators) => {
    for (let key in hierarchy) {
      if (selectedBuildings.length > 0 && !selectedBuildings.includes(hierarchy[key].building_distribution?.trim())) continue
      let actuator = actuators ? actuators.find(e=>parseInt(e.channel_id) === parseInt(hierarchy[key]?.id)) : null
      let node = {
        id: hierarchy[key].id,
        name: hierarchy[key].channel_name.trim(),
        channel_id: hierarchy[key].id,
        alerts: alerts[hierarchy[key].id],
        parent: parent === null ? parent : parent.trim(),
        selected: false,
        actuator: actuator,
        device: hierarchy[key].device_id.trim(),
        collapsed: false,
        dataType: type,
        shape: {
          type: "HTML",
          content: hierarchy[key].channel_name.trim(),
        },
      };
      auxHierarchy.push(node);
      if (!isEmpty(hierarchy[key].children)) {
        DiagramFuncs.dTreeGenerator(auxHierarchy, hierarchy[key].children, key, selectedBuildings, type, alerts, actuators);
      }
    }
  },

  deviceTreeGenerator: (auxHierarchy, channels, selectedBuildings, alerts) => {
    let addedCircuits = []
    let devices = []
    for (let channel of channels) {
      if (selectedBuildings.length > 0 && !selectedBuildings.includes(channel.building_distribution)) continue
      if (channel.device_id && !devices.includes(channel.device_id)) {
        let node = {
          id: "Device: " + channel.device_id.trim(),
          channel_id: "Device: " + channel.device_id.trim(),
          name: "Device: " + channel.device_id.trim(),
          parent: null,
          alerts: alerts[channel.device_id],
          device_id: channel.device_id,
          selected: false,
          collapsed: false,
          dataType: 'device',
          shape: {
            type: "HTML",
            content: "Group: " + channel.device_id.trim(),
          },
        };
        auxHierarchy.push(node);
        devices.push(channel.device_id.trim(),)
      }
      if (channel.device_id && !addedCircuits.includes(channel.channel_name.trim())) {
        let node = {
          id: channel.channel_name.trim(),
          name: channel.channel_name.trim(),
          alerts: null,
          channel_id: channel.id,
          phasing_error: channel.phasing_error,
          parent: "Device: " + channel.device_id.trim(),
          selected: false,
          collapsed: false,
          device: channel.device_id.trim(),
          dataType: 'circuit',
          shape: {
            type: "HTML",
            content: channel.channel_name.trim(),
          },
        };
        auxHierarchy.push(node);
        addedCircuits.push(channel.channel_name.trim())
      }
    }
  },

  addSources: (auxHierarchy, e_sources, hierarchy) => {
    let main = auxHierarchy.find(jsonObj => jsonObj.parent === null);
    if (!main) return
    let mainParents = []
    let index = 0
    for (let [ix, source] of e_sources.entries()) {
      if (source.channels && source.channels.length > 0 && source.sub_category && source.sub_category.trim().toLowerCase() === 'utility') index = ix
      mainParents.push(source.id)
      let node = {
        id: source.id,
        name: source.channel_name,
        parent: null,
        selected: false,
        dataType: "circuit",
        device: source.device_id,
        channel_id: source.id,
        phasing_error: source.phasing_error,
        collapsed: false,
        shape: {
          type: "HTML",
          content: source.channel_name,
        },
      };
      auxHierarchy.push(node);
    }
    main.parent = e_sources.length > 0 ? e_sources[index].id : null
  }
}
export default DiagramFuncs